import React, { useState, useEffect } from "react";
import NavbarComponent from "../Navbardummy.js";
import axios from "axios";
import Swal from "sweetalert2";
const API_URL = process.env.REACT_APP_API_URL_EC2;
const token = process.env.REACT_APP_API_TOKEN;

const PreferencePage = () => {
  const [preference1, setPreference1] = useState("");
  const [id, setid] = useState();
  const [email, setemail] = useState();

  useEffect(() => {
    const storedUserdata = sessionStorage.getItem("user");
    if (storedUserdata) {
      const data = JSON.parse(storedUserdata);
      if (data.id) {
        setid(data.id);
        setemail(data.email);
      } else {
        console.error("ID is not available in stored user data.");
      }
    }
  }, []);

  const preferences = [
    {
      id: "clothing",
      label: "Clothing",
      imageUrl: "assets/img/portfolio/Clothing.jpg",
    },
    {
      id: "gaming",
      label: "Gaming",
      imageUrl: "assets/img/portfolio/Gaming.jpg",
    },
    {
      id: "watches",
      label: "Watches",
      imageUrl: "assets/img/portfolio/Watches.jpg",
    },
    {
      id: "books",
      label: "Books",
      imageUrl: "assets/img/portfolio/Books.jpg",
    },
  ];

  const handleSelect = (id) => {
    setPreference1(id);
  };

  const SubmitPreference = async () => {
    if (true) {
      let response = await axios.post(
        `${API_URL}/api/UpdateCategoryPreference2`,
        {
          id: id,
          key: "categorypreference2",
          value: preference1,
        }
      );

      console.log(response);
      if (response.data.success) {
        if (response.data.data.categorypreference1 === "") {
          window.open("/categorypreference1", "_self");
        } else if (response.data.data.categorypreference2 === "") {
          window.open("/categorypreference2", "_self");
        } else {
          // Set headers with the Bearer token
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          // Send the POST request with headers and product data
          const responseemail = await axios.post(
            `${API_URL}/api/sendemail`,
            {
              userId: 1,
              subject: "Preference Notification",
              message: `categorypreference1: ${response.data.data.categorypreference1}, categorypreference2:${response.data.data.categorypreference2}`,
              email: email,
            },
            { headers } // Include headers in the request
          );

          window.open("/dashboard", "_self");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Preference Setting Failed",
          text: response.data.message,
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh", // Allow content to grow naturally
        width: "100%", // Full-page width
        background: "linear-gradient(to bottom, #f2d7d9, #f9e7e9, #ffffff)",
      }}
    >
      {/* Navbar at the top */}
      <NavbarComponent />

      {/* Content Section */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "5px",
          marginTop: "10px", // Add space below the navbar
        }}
      >
        <h2 style={{ color: "#000", marginBottom: "30px", fontWeight: "bold" }}>
          Second Movie Preference
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
            gap: "30px",
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          {preferences.map((preference) => (
            <div
              key={preference.id}
              onClick={() => handleSelect(preference.id)}
              style={{
                cursor: "pointer",
                border:
                  preference1 === preference.id
                    ? "8px solid #2e6b31"
                    : "3px solid #ccc",
                borderRadius: "15px",
                overflow: "hidden",
                boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.2)",
                transition: "transform 0.3s",
                transform:
                  preference1 === preference.id ? "scale(1.05)" : "scale(1)",
              }}
            >
              <img
                src={preference.imageUrl}
                alt={preference.label}
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <h2
                style={{
                  padding: "20px",
                  margin: 0,
                  textAlign: "center",
                  backgroundColor: "#f4f4f4",
                }}
              >
                {preference.label}
              </h2>
            </div>
          ))}
        </div>

        <div style={{ marginTop: "30px" }}>
          {preference1 ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px", // Adjust the gap between elements
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  color: "#000",
                  fontWeight: "bold",
                  margin: 0, // Remove extra margin to align properly
                }}
              >
                You selected: <strong>{preference1}</strong>
              </p>
              <button
                style={{
                  padding: "12px 25px",
                  fontSize: "16px",
                  color: "#fff",
                  backgroundColor: "#000000",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  transition: "background-color 0.3s, transform 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#2e6b31")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#000000")
                }
                onMouseDown={(e) => (e.target.style.transform = "scale(0.95)")}
                onMouseUp={(e) => (e.target.style.transform = "scale(1)")}
                onClick={() => SubmitPreference()}
              >
                Save & Next
              </button>
            </div>
          ) : (
            <p style={{ fontSize: "18px", color: "#000", fontWeight: "bold" }}>
              Please select a preference.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreferencePage;
